// extracted by mini-css-extract-plugin
module.exports = {"search-breadcrumb":"SearchBreadcrumb_search-breadcrumb__muAhW"};